jQuery(document).ready(function($) {
    MbccMain = new function()
    {
        this.init = function() {
            //Select with Search
            $('.select-search').select2();

            //Can't find system form popup
            jQuery(document).ready(function($) {
                jQuery('.cant-find').magnificPopup({
                  type:'inline',
                  midClick: true,
                  mainClass: 'cant-find-mfp',
                  closeBtnInside: true
                });
            });
        };
    }

    MbccMain.init();
});
